import { useState, useEffect, useCallback, Fragment } from "react";
import { Table, Card, CardHeader, CardTitle } from "reactstrap";
import Select from "react-select";
import { H5, H4, Btn } from "../../../../AbstractElements";
import {
    DeleteLabExpenses,
    ListLabExpenses,
  StoreLabExpenses,
  UpdateLabExpenses,
} from "../../../../apiController";
import {
  Button,
  Modal,
  ModalHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Input,
  ModalBody,
  Form,
  Row,
  Col,
} from "reactstrap";
import DataTable from "react-data-table-component";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { ImageModal } from "../../Patient/PatientPage/PatientTreatmentInfo/MedicalReport";


const LabPayment = ({permission}) => {
  const [expense, setExpense] = useState([]);
  const [selectedMonthID, setSelectedMonthID] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [Large, setLarge] = useState(false);
  const [edit, setEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filePreview, setFilePreview] = useState("");



  const toggleModal = () => {
    setLarge(!Large);
  };

  const toggle = (monthID) => {
    setSelectedMonthID(monthID);
    setSelectedRows([]);
    setShowDetails(!showDetails);
  };

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);


  // ------------------------- Handle Delete Function --------
  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: 'Are you sure you want to delete?',
      cancelButtonText: 'No!',
      confirmButtonText: 'Yes!',
      reverseButtons: true,
      showCancelButton: true,
    });
  
    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map(row => row.id); 
        await Promise.all(selectedIds.map(id => DeleteLabExpenses(id)));
        setSelectedRows([]);
        toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
        fetchotherExpense();
      } catch (error) {
        toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
    }
  };


  const type = expense
    .filter((row) => row.month === selectedMonthID && row.year === selectedYear)
    .flatMap((row) =>
      row.data.map((row, ind) => {
        //   const fileUrl = URL.createObjectURL(row.bill_copy);
        return {
          ind: ind + 1,
          id: row.id,
          invoice: row.invoice_no,
          billCopy: (
            <a
              href={row.bill_copy}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Bill
            </a>
          ),
          name: row.company_name,
          pharmacyAmt: row.amount,
          paymentStatus: row.status,
          action: (
            <span key={ind}>
              <Btn
                attrBtn={{
                  style: { width: 60, fontSize: 14, padding: 4 },
                  color: "success",
                  className: "btn btn-xs",
                  type: "button",
                  onClick: () => handleEdit(row),
                }}
              >
                Edit
              </Btn>
            </span>
          ),
        };
      })
    );

  const monthDataColumns = [
    { name: "#", selector: (row) => row.ind, sortable: true },
    {
      name: "Company",
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: "Bill Copy",
        selector: (row) => row.billCopy,
      sortable: true,
      center: true,
    },
    {
      name: "Invoice",
      selector: (row) => row.invoice,
      sortable: true,
      center: true,
    },
    {
      name: "Amount",
      selector: (row) => row.pharmacyAmt,
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.paymentStatus,
      sortable: true,
      center: true,
    },
    // {
    //   name: "Edit",
    //   selector: (row) => row.action,
    //   center: true,
    // },
  ];

  if(permission?.edit_access){
    monthDataColumns.push({
      name: "Edit",
      selector: (row) => row.action,
      center: true,
    },)
  }

  const tableHeader = ["#", "Month", "Total"];
  const months = [
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
  ];

  useEffect(() => {
    fetchotherExpense();
  }, []);

  const fetchotherExpense = async () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const response = await ListLabExpenses({month: currentMonth});
    if (response.status === true) {
      setExpense(response.sum.reverse());
      const uniqueYears = [...new Set(response.sum.map(item => item.year))];
      const yearOptions = uniqueYears.map(year => ({ value: year, label: year }));
      setOptions(yearOptions);
    }
  };

  const handleEdit = (row) => {
    console.log("Edit row:", row);
    setLarge(!Large);
    setValue("invoice_no", row.invoice_no);
    setValue("company_name", row.company_name);
    setValue("amount", row.amount);
    setValue("status", row.status);
    setValue("bill_copy", row.bill_copy);
    setFilePreview(row.bill_copy);
    setValue("id", row.id);
    setEdit(!edit);
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(filePreview);
    const formData = new FormData();
    formData.append("invoice_no", data.invoice_no);
    formData.append("company_name", data.company_name);
    formData.append("amount", data.amount);
    formData.append("status", data.status);
    formData.append("bill_copy", data.bill_copy);
    formData.append("id", data.id);

    for (const [key, value] of formData.entries()) {
      console.log(key, value);
    }

    if (!edit) {
      storeExpenses(formData);
    }else(
        updateExpenses(formData)
    )
  };

  const storeExpenses = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await StoreLabExpenses(formData);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchotherExpense();
      reset();
      setFilePreview("");
      setLarge(!Large)
      setIsSubmitting(false);
    }
  };


  const updateExpenses = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await UpdateLabExpenses(formData);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchotherExpense();
      reset();
      setFilePreview("");
      setLarge(!Large);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {!showDetails && (
        <Card>
          <CardHeader className="d-flex gap-4 justify-content-evenly align-items-center">
            <CardTitle>Select Year</CardTitle>
            <Select
              options={options}
              className="js-example-basic-single col-sm-3"
              value={options.find((option) => option.value === selectedYear)}
              onChange={(option) => setSelectedYear(option.value)}
            />
            <H5 className="align-self-end">Lab Expenses</H5>
            {permission?.create_access && <button
              type="button"
              className="btn btn-primary"
              aria-hidden="true"
              onClick={toggleModal}
              style={{ cursor: "pointer", backgroundColor: "#145BD9" }}
            >
              <span className="me-1">+</span>
              Add Lab Expenses
            </button>}
          </CardHeader>
          <Table responsive striped>
            <thead>
              <tr className="text-center">
                {tableHeader.map((heads, i) => (
                  <th key={i}>{heads}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {months.map((data) => (
                <tr className="text-center" key={data.id}>
                  <td>{data.id}</td>
                  <td>
                    <span
                      onClick={() => toggle(data.id)}
                      style={{ cursor: "pointer" }}
                       className="f-w-700 font-info"
                    >
                      {data.month}
                    </span>
                  </td>
                  <td>
                    {expense
                      .filter(
                        (main) =>
                          main.month === data.id && main.year === selectedYear
                      )
                      .map((main, index) => (
                        <span key={index}>
                          {main.lab_accounts || "--"}
                        </span>
                      ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
      {showDetails && (
        <Card>
          <CardHeader
            toggle={() => toggle(null)}
            className=" bg-light"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span className=" bg-light ">
              Details for{" "}
              {months.find((m) => m.id === selectedMonthID)?.month || "N/A"}
            </span>
          </CardHeader>
          <CardBody>
            <Fragment>
              {selectedRows.length !== 0 && (
                <div className="d-flex align-items-center justify-content-between bg-light-info p-2">
                  <H4 attrH4={{ className: "text-muted m-0" }}>
                    Delete Selected Data..!
                  </H4>
                  <Btn attrBtn={{ color: "danger", onClick: () => handleDelete() }}>
                    Delete
                  </Btn>
                </div>
              )}
              <DataTable
                data={type}
                columns={monthDataColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
              />
            </Fragment>
          </CardBody>
          <CardFooter>
            <Button color="secondary" onClick={() => toggle(null)}>
              Back
            </Button>
          </CardFooter>
        </Card>
      )}

      <Modal isOpen={Large} toggle={toggleModal} centered>
        <ModalHeader className="text-white bg-dark p-2 justify-content-center">
          Lab Expenses
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody>
              <Form
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <CardBody>
                  <Row>
                    <Col>
                      <FormGroup className="row">
                        <Label className="col-sm-3 col-form-label">
                          Company Name
                        </Label>
                        <Col sm="9">
                          <Controller
                            name="company_name"
                            control={control}
                            rules={{
                              required: true,
                              maxLength: 150,
                              pattern: /^[A-Za-z\s-,/.()'"]*$/,
                            }}
                            render={({ field }) => (
                              <Input
                                type="text"
                                placeholder="Name"
                                {...field}
                                className={`form-control ${
                                  errors.company_name ? "is-invalid" : ""
                                }`}
                                onChange={(e) => {
                                  const sanitizedValue = e.target.value.replace(
                                    /[^A-Za-z\s-,/.()'"]/g,
                                    ""
                                  );
                                  field.onChange(sanitizedValue.slice(0, 150));
                                }}
                              />
                            )}
                          />
                          <span className="text-danger">
                            {errors.company_name && "Company Name is required"}
                          </span>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="row">
                        <Label className="col-sm-3 col-form-label">
                          Amount
                        </Label>
                        <Col sm="9">
                          <Controller
                            name="amount"
                            control={control}
                            rules={{ required: true, pattern: /^[0-9]*$/ }}
                            render={({ field }) => (
                              <Input
                                type="text"
                                placeholder="Amount"
                                {...field}
                                className={`form-control ${
                                  errors.amount ? "is-invalid" : ""
                                }`}
                                onChange={(e) =>
                                  field.onChange(
                                    e.target.value.replace(/[^0-9]/g, "")
                                  )
                                }
                              />
                            )}
                          />
                          <span className="text-danger">
                            {errors.amount && "Amount is required"}
                          </span>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="row">
                        <Label className="col-sm-3 col-form-label">
                          Invoice No
                        </Label>
                        <Col sm="9">
                          <Controller
                            name="invoice_no"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Input
                                type="text"
                                placeholder="Invoice NO"
                                {...field}
                                className={`form-control ${
                                  errors.invoice_no ? "is-invalid" : ""
                                }`}
                              />
                            )}
                          />
                          <span className="text-danger">
                            {errors.invoice_no && "Invoice No is required"}
                          </span>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="row">
                        <Label className="col-sm-3 col-form-label">
                          Bill Copy
                        </Label>
                        <Col sm="9">
                          <Controller
                            name="bill_copy"
                            control={control}
                            rules={{ required: false }}
                            render={({
                              field: { onChange, onBlur, value, ref },
                            }) => (
                              <>
                                <Input
                                  type="file"
                                  accept=".jpg,.jpeg,.png,.svg,.pdf"
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    onChange(file);
                                  }}
                                  onBlur={onBlur}
                                  ref={ref}
                                  className={`form-control ${
                                    errors.bill_copy ? "is-invalid" : ""
                                  }`}
                                />
                                <span className="text-danger">
                                  {errors.bill_copy && "Bill Copy is required"}
                                </span>
                              </>
                            )}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <FormGroup className="row">
                        <Label className="col-sm-3 col-form-label">
                          Status
                        </Label>
                        <Col sm="9">
                          <Controller
                            name="status"
                            control={control}
                            rules={{
                              required: true,
                              maxLength: 150,
                              pattern: /^[A-Za-z\s-,/.()'"]*$/,
                            }}
                            render={({ field }) => (
                              <Input
                                type="text"
                                placeholder="Status"
                                {...field}
                                className={`form-control ${
                                  errors.status ? "is-invalid" : ""
                                }`}
                                onChange={(e) => {
                                  const sanitizedValue = e.target.value.replace(
                                    /[^A-Za-z\s-,/.()'"]/g,
                                    ""
                                  );
                                  field.onChange(sanitizedValue.slice(0, 150));
                                }}
                              />
                            )}
                          />
                          <span className="text-danger">
                            {errors.status && "Status is required"}
                          </span>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        className="success"
                        color="success"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "submit"}
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        className="primary"
                        onClick={() => setLarge(!Large)}
                      >
                        {"Cancel"}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Form>
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    </>
  );
};

export default LabPayment;
